import React from 'react';

/**
 * 荣誉预览 - 显示当前称号，点击进入荣誉页
 */
const CheckinHonorsPreview = React.memo(({ title, badges = [], onClick }) => {
    return (
        <div className="checkin-honors-preview" onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onClick()}>
            <div className="honors-title-row">
                <span className="label">我的荣誉</span>
                <span className="value">{title || '暂无称号'}</span>
            </div>
            <div className="honors-badges-mini">
                {badges.slice(0, 5).map((b) => (
                    <span key={b.id} className={`badge-mini ${b.got ? 'got' : ''}`} title={b.name}>
                        {b.icon}
                    </span>
                ))}
                {badges.length > 5 && (
                    <span className="badge-mini more">+{badges.length - 5}</span>
                )}
            </div>
            <span className="arrow">›</span>
        </div>
    );
});

export default CheckinHonorsPreview;
